import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import _ from 'lodash';

import * as actions from '../../../../actions';

import Step from '../../../parts/Step';
import {Maybe} from '../../../../utils/logging';
import {setLanguageIndex, checkboxLog, selectLog, extractKTIEFE, generateSummary} from '../../../../utils/helpers';

class DwdfSummary extends Component {

    render() {
        const getLanguageIndex = setLanguageIndex(this.props.currentLanguge);
        const getS023 = generateSummary(this.props.dwdf.SO23,getLanguageIndex);
        const getS045 = generateSummary(this.props.dwdf.SO45,getLanguageIndex);
        const getS067 = generateSummary(this.props.dwdf.SO67,getLanguageIndex);
        const gets081 = generateSummary(this.props.dwdf.SO81,getLanguageIndex);
        var details = [];
        let depthValue = this.props.dwdf.KTIEFE && extractKTIEFE(this.props.dwdf.KTIEFE) ? 'x ' + extractKTIEFE(this.props.dwdf.KTIEFE) : '';
        Maybe.of(this.props.dwdf.W_BREITE && this.props.dwdf.W_LAENGE)
            .map(() => {
                return this.props.dwdf.W_BREITE.CurrentValue && this.props.dwdf.W_LAENGE.CurrentValue
            })
            .map(() => {
                if (parseInt(this.props.dwdf.VAR_ABM.CurrentValue) === 0) {
                    details.push(`${this.props.translate(`DWDF.stepOne.menu.body.1`)} ${this.props.dwdf.W_LAENGE.CurrentValue} cm x ${this.props.dwdf.W_BREITE.CurrentValue} cm  ${depthValue}  `);
                    details.push(`${gets081 ? gets081 : ''}`);
                    details.push(`${getS023 ? getS023 : ''}`);
                    details.push(`${getS045 ? getS045 : ''}`)
                    details.push(`${getS067 ? getS067 : ''}`)
                }
            });
        Maybe.of(this.props.dwdf.VAR_ABM)
            .map((var_abm) => {
                details.push(`${this.props.translate(`DWDF.stepOne.menu.body.2`)} ${this._calculateSize('lange')} cm x ${this._calculateSize('breite')} cm  ${depthValue}`);
            });

        const ZT = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return parseInt(field.CurrentValue);
            })
            .map((field_value) => {
                details.push(`${this.props.translate(`DWDF.stepTwo.menu.body.1`)} Z${this.props.dwdf.ZT.CurrentValue}`);
            })
        };
        ZT(this.props.dwdf.ZT);

        const ZARGE = (field) => {
            return Maybe.of(this.props.dwdf[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value === '0') {
                        Maybe.of(this.props.dwdf[`${field}_switch`])
                        .map((zswitch) => {
                            return zswitch.CurrentValue;
                        })
                        .map((zswitch_value) => {
                            if(zswitch_value !== '0') {
                                details.push(this.props.translate(`DWDF.stepTwo.summary.${field}.${zswitch_value}`));
                            }
                        });
                    }
                    if(field_value !== '0') {
                        const measure = this.props.dwdf[field.replace(/Z/g, "ZM")].CurrentValue + " cm";
                        details.push(`${this.props.translate(`DWDF.stepTwo.summary.${field}.${field_value}`)} ${measure}`);
                    }
                })
        };

        ['Z23', 'Z45', 'Z67', 'Z81'].forEach((field) => {
            ZARGE(field);
        });

        const CORNER = (field) => {
            let corner, choice, title;
            return Maybe.of(this.props.dwdf[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value !== '0' && field_value !== '01') {
                        title = this.props.translate(`DWDF.stepThree.menu.title2`);
                        corner = this.props.translate(`DWDF.stepThree.menu.body.${field}`);
                        choice = this.props.dwdf[field].Values.Value.find(((el) => {return parseInt(el.Code) === parseInt(field_value)})).Description[`${setLanguageIndex(this.props.currentLanguge)}`];
                        details.push(`${title}: ${corner}: ${choice}`);
                    }
                })
        };

        ['EA12', 'EA34', 'EA56', 'EA78'].forEach((field) => {
            CORNER(field);
        });

        const SZ = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return parseInt(field.CurrentValue);
            })
            .map((field_value) => {
                details.push(`${this.props.translate(`DWDF.stepFour.form.title`)} S${this.props.dwdf.SZ.CurrentValue}`);
                return;
            })
        };

        SZ(this.props.dwdf.SZ);

        const SCHUERZE = (field) => {
            return Maybe.of(this.props.dwdf[field])
                .map((field) => {
                    return field.CurrentValue;
                })
                .map((field_value) => {
                    if(field_value === '0') {
                        Maybe.of(this.props.dwdf[`${field}_switch`])
                        .map((zswitch) => {
                            return zswitch.CurrentValue;
                        })
                        .map((zswitch_value) => {
                            if(zswitch_value !== '0') {
                                details.push(this.props.translate(`DWDF.stepFour.summary.${field}.${zswitch_value}`));
                            }
                        });
                    }
                    if(field_value !== '0') {
                        const measure = this.props.dwdf[field.replace(/S/g, "SM")].CurrentValue + " cm";
                        details.push(`${this.props.translate(`DWDF.stepFour.summary.${field}.${field_value}`)} ${measure}`);
                    }
                })
        };

        ['S23', 'S45', 'S67', 'S81'].forEach((field) => {
            SCHUERZE(field);
        });

        const SH = (field) => {
        return Maybe.of(field)
            .map((field) => {
                return parseFloat(field.CurrentValue);
            })
            .map((field_value) => {
                details.push(`${this.props.translate(`DWDF.stepFour.menu.sheight`)} ${field_value} cm`);
                return;
            })
        };

        SH(this.props.dwdf.SH);

        const checkboxContent = [];

        // Set FA
        Maybe.of(selectLog(this.props, 'dwdf', 'FA',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
            .map((value) => {
                let farbe = this.props.translate(`DWDF.stepFive.menu.title2`);
                details.push(`${farbe}: ${value}`);
                return true;
            });

        // Set GT
        Maybe.of(checkboxLog(this.props, 'dwdf', 'GT', 'stepFive')._value)
            .map((value) => {
                checkboxContent.push(value);
                return true;
            });

        // Set OV
        Maybe.of(checkboxLog(this.props, 'dwdf', 'OV', 'stepFive')._value)
            .map((value) => {
                checkboxContent.push(value);
                return true;
            });
        details.push(checkboxContent.join(', '));
        return details.map((item, index) => {
            return (
                <div key={index}>{item}</div>
            )
        })
    }

    _calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return field.CurrentValue;
            })._value || 0;
        }
        if (type === 'lange') {
            if(parseInt(this.props.dwdf.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.dwdf.W_LAENGE.CurrentValue));
            } else {
                const w_laenge = getValue(this.props.dwdf.W_LAENGE);
                const SO45 = parseFloat(getValue(this.props.dwdf.SO45));
                const SO81 = parseFloat(getValue(this.props.dwdf.SO81));

                return w_laenge + SO45 + SO81;
            }
        }
        if (type === 'breite') {
            if (parseInt(this.props.dwdf.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.dwdf.W_BREITE.CurrentValue));
            } else {
                const w_breite = getValue(this.props.dwdf.W_BREITE);
                const SO23 = parseFloat(getValue(this.props.dwdf.SO23));
                const SO67 = parseFloat(getValue(this.props.dwdf.SO67));

                return w_breite + SO23 + SO67;
            }
        }
    }

}


function mapStateToProps({dwdf, locale}) {
    return {
        translate:      getTranslate(locale),
        currentLanguge: getActiveLanguage(locale).code,
        dwdf,
    }
}

export default connect(mapStateToProps, actions)(DwdfSummary);



// WEBPACK FOOTER //
// ./src/components/download/additionalInfo/summary/DwdfSummary.js